import { SunIcon, MoonIcon } from '@phosphor-icons/react';
import { useThemeStore } from '@/store/theme/store';
import { usePlatformSettingsStore, selectFeatures } from '@/store/platform-settings/store';
import { useTranslation } from 'react-i18next';

export default function ThemeToggle() {
  const { t, i18n } = useTranslation();
  const theme = useThemeStore((state) => state.theme);
  const nextTheme = theme === 'dark' ? 'light' : 'dark';
  const toggleTheme = useThemeStore((state) => state.toggleTheme);
  const features = usePlatformSettingsStore(selectFeatures);
  const config = {
    lang: (i18n?.language || "en")
  };

  // Check if theme is forced
  const forceTheme = features.FORCE_THEME;
  const isThemeForced = forceTheme && typeof forceTheme === 'string' && forceTheme.trim() !== '';

  let themeLabel = '';
  if (config.lang === 'fr') {
    themeLabel = `${t('common.theme.switch')} ${t('common.theme.name')} ${t('common.theme.' + nextTheme)}`;
  } else {
    themeLabel = `${t('common.theme.switch')} ${t('common.theme.' + nextTheme)} ${t('common.theme.name')}`;
  }

  // If theme is forced, hide the toggle
  if (isThemeForced) {
    return null;
  }

  return (
    <button
      onClick={toggleTheme}
      className="topbar-btn"
      style={{
        border: 'none',
      }}
      aria-label={themeLabel}
      title={themeLabel}
    >
      {theme === 'dark' ? <SunIcon size={20} weight="fill" /> : <MoonIcon size={20} weight="fill" />}
    </button>
  );
}
